














import { Vue, Component } from 'vue-property-decorator';
import {
  PartnerApi,
  FwUser,
  FwUserApi,
} from '@compassdigital/foodworks.api.ts';
import Sidebar from './sidebar.vue';

@Component({
  components: {
    Sidebar,
  },
})
export default class PartnerLayout extends Vue {
}
